import React, { PureComponent } from 'react'
import { Link, withRouter } from 'react-router'
import { withoutNulls } from 'lib/object'
import cx from 'classnames'

class PatchLink extends PureComponent {
  render() {
    const {
      query,
      params,
      location,
      routes,
      children,
      router,
      allowEmpty = true,
      mergeQuery = true,
      avoidHref = false,
      className,
      track,
      trackAs,
      ...otherProps
    } = this.props

    const trackAsClass = trackAs ? `track-as-${trackAs}` : null
    const classes = cx(className, trackAsClass)

    // Adobe Analytics doesn't play nice with href-ed anchors that exist within a SVG because
    // href is represented by SVGAnimatedString instead of just String. For SBI easing shapes,
    // render anchor ourselves and use handler instead of letting react-router's Link
    // generate an anchor with an href.
    if (avoidHref) {
      return (
        <a
          onClick={this.onClick}
          {...otherProps}
          className={classes}
          data-track={track}
        >
          {children}
        </a>
      )
    }

    const finalQuery = mergeQuery ? { ...location.query, ...query } : query

    const to = {
      ...location,
      params: params,
      query: allowEmpty ? finalQuery : withoutNulls(finalQuery)
    }

    return (
      <Link to={to} {...otherProps} className={classes} data-track={track}>
        {children}
      </Link>
    )
  }

  onClick = e => {
    e.preventDefault()

    const {
      query,
      params,
      location,
      router,
      allowEmpty = true,
      mergeQuery = true
    } = this.props

    const finalQuery = mergeQuery ? { ...location.query, ...query } : query

    const to = {
      ...location,
      params: params,
      query: allowEmpty ? finalQuery : withoutNulls(finalQuery)
    }

    router.push(to)
  }
}

export default withRouter(PatchLink)



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/patch-link.js